import PageBanner from "@/components/public/PageBanner";
import Directory from "@/components/landing/Directory";
import Oportunidades from "@/components/landing/Oportunidades";
import LeasingForm from "@/components/landing/LeasingForm";
import { useMedia } from "@/context/MediaContext";

export default function LojasPage() {
  const { banner_lojas } = useMedia();

  return (
    <>
      <PageBanner
        image={banner_lojas?.image}
        overline="Lojas & Espaços"
        title={banner_lojas?.title}
        subtitle={banner_lojas?.subtitle}
      />
      <Oportunidades />
      <Directory />
      <LeasingForm />
    </>
  );
}
